import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateOrderStatus, ordersQueryKeys, type Order } from '@api/orders';
import { toastWithLink } from '@/components/ui/toast';
import { useTranslation } from '../useTranslation';

interface UpdateOrderStatusVariables {
  id: number;
  status: 'lead' | 'confirmed' | 'cancelled';
  cancellation_reason?: string;
}

export function useUpdateOrderStatus() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ id, status, cancellation_reason }: UpdateOrderStatusVariables) =>
      updateOrderStatus(id, status, cancellation_reason),
    onSuccess: (data: Order) => {
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.detail(data.id) });
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.lists() });
      toastWithLink({
        name: data.reference_number,
        href: `/orders/${data.id}/details`,
        label: t(`toast.order_status.${data.order_status}`),
        ...(data.order_status === 'cancelled' ? { variant: 'destructive' as const } : {}),
      });
    },
  });
}
